export default __webpack_public_path__ + "static/media/Counter_product_1.4589c517.jpg";